import React, { Component } from 'react';
import * as api from '../../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import StatusMessage from '../../util/StatusMessage'

class InstitutionGroupReport extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      loading: false,
      data:{
        'tpoInstEligbility': [],
        'tpoGroupEligbility': []
      },
    };
  
        
  }

  componentDidMount() {

    let data = Object.assign({}, this.state.data)
     return api.getInstGroupReportEligibility(this.props.user.accessToken)
      .then((result) => {
        
        data.tpoInstEligbility = result.inst_eligibility
        data.tpoGroupEligbility = result.group_eligibility
        this.setState({data: data})
    })

  };

  setLoadingState = (stateValue, errorMsg) =>{
    this.setState({ loading: stateValue, errorMsg: errorMsg})
  }

  fetchInstGroupReport = (e, report_type, test_cycle) => {
    this.setLoadingState(true)
    console.log(report_type)
    console.log(test_cycle)
    api.downloadInstGropuReportReport(this.props.user.accessToken, report_type, test_cycle)
      .then((result) => {
         if (result instanceof Blob){
          this.setState({ errorMsg: '' })
          this.setLoadingState(false, '')
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'TpoInstGroupReport.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({ errorMsg: 'Unable to download reports. Please contact Administrator' })
          this.setLoadingState(false, 'Unable to download reports. Please contact Administrator')
        }      
      }).catch((err) => {
          this.setState({ errorMsg: 'Unable to downlod reports. Plaase contact Admin' })
          this.setLoadingState(false, 'Unable to download reports. Please contact Admin')
      })
  }
  

  render() {

  let content
  let fetchInstGroupReport = this.fetchInstGroupReport
  
  let tpoInstContent
    
    if(this.state.data.tpoInstEligbility.length > 0){
      tpoInstContent = (
        <div>
          <br/>
            <Typography use="headline6">TPO Institution Report</Typography>
            <table>
              <thead>
                <tr>
                  <th>Institution</th>
                  <th>Year</th>
                  <th>Download Link</th> 
                </tr>
              </thead>
              <tbody>
                {this.state.data.tpoInstEligbility.map(instelig => (
                <tr>
                  <td>
                    {instelig.institution}
                  </td>
                  <td>
                    {instelig.test_cycle}
                  </td>
                  <td>
                    <Button outlined className="button-link" onClick={((e) => fetchInstGroupReport(e, instelig.report_type, instelig.test_cycle))}>Download</Button>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>  
        </div>    
        )
    }


    let tpoGroupContent
    
    if(this.state.data.tpoGroupEligbility.length > 0){
      tpoGroupContent = (
        <div>
          <br/>
            <Typography use="headline6">TPO Group Report</Typography>
            <table>
              <thead>
                <tr>
                  <th>Group Name</th>
                  <th>Year</th>
                  <th>Download Link</th> 
                </tr>
              </thead>
              <tbody>
                {this.state.data.tpoGroupEligbility.map(groupelig => (
                <tr>
                  <td>
                    {groupelig.group}
                  </td>
                  <td>
                    {groupelig.test_cycle}
                  </td>
                  <td>
                    <Button outlined className="button-link" onClick={((e) => fetchInstGroupReport(e, groupelig.report_type, groupelig.test_cycle))}>Download</Button>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>  
        </div>    
        )
    }

  if(!this.state.loading){
       content = <div class="mdc-layout-grid">
          <div class="mdc-layout-grid__inner"> 
            <div class="mdc-layout-grid__cell--span-10">
              <Typography use="headline5">Institution Group Performance Reports</Typography>
              <br/>
              <Typography use="content"> (Institution & Group wise performance report, if any will be displayed here)</Typography>
              {tpoInstContent}
              {tpoGroupContent}
              <StatusMessage error_msg = {this.state.errorMsg}/>
                            
            <div class="mdc-layout-grid__cell--span-1"></div>
            <div class="mdc-layout-grid__cell--span-1"></div>
          </div>
        </div>
      </div>
    }

    else{
      content = (
          <div className="loader-component">
            <div className="loader"></div>
            <h4> Report is being generated. Please wait</h4>
          </div>
        )
    }


   return(
        <div>
          {content}
        
        </div>
      )
    
  }

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionGroupReport);



// WEBPACK FOOTER //
// ./src/views/institutionadmin/InstitutionGroupReport.jsx